module.exports = __webpack_public_path__ + "static/media/3.64b109ce.svg";